var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ok)?_c('div',{staticClass:"mt-1"},[_c('b-btn',{attrs:{"variant":"primary"},on:{"click":_vm.displayAddForm}},[_c('span',{staticClass:"glyphicon glyphicon-plus"})])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }